import { DOCUMENT_TYPES } from '@savgroup-front-common/constants';
import { DocumentData } from '@savgroup-front-common/core/formatters/getDocumentNameTranslated';
import { FileLabel } from '@savgroup-front-common/types';

interface AdaptShippingLabelsToDocumentDataArgs {
  shippingLabels?: FileLabel[];
}

export const adaptShippingLabelsToDocumentData = ({
  shippingLabels,
}: AdaptShippingLabelsToDocumentDataArgs): DocumentData[] => {
  return (shippingLabels || [])
    .filter((label) => !label.disabled && label.customerVisibility && label.hasLabelGenerated)
    .map((label) => ({
      ...label,
      type: DOCUMENT_TYPES.SHIPPING_LABEL,
      documentName: DOCUMENT_TYPES.SHIPPING_LABEL,
    }));
};
